import Calendar from "../../../../src/components/table";
import * as React from 'react';
export default {
  Calendar,
  React
};